import {
	GovControlGroup,
	GovDropdown,
	GovFlex,
	GovIcon,
} from '@gov-design-system-ce/react';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { useMojeSouborySeznamContext } from '@gov-nx/module/page';
import { Button, Icon } from '@gov-nx/ui/web';

export const Actions = () => {
	const {
		code,
		deleteConfirm,
		deletePermanentConfirm,
		myFilesDownload,
		myFilesSelection,
	} = useMojeSouborySeznamContext();
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tsn = getLocalizeCurried(code);

	return (
		<GovFlex gap="s">
			<Button
				aria-label={tsn('akce.stahnout')}
				color="primary"
				type="solid"
				size="s"
				isExpandedMobile
				isLoading={myFilesDownload.isAnyDocumentDownloading}
				isDisabled={myFilesSelection.isItemWithNoFileInSelection}
				onClick={() =>
					myFilesDownload.downloadSelectedDocuments(myFilesSelection.selected)
				}
				iconStart={
					<Icon
						type="templates"
						name="download"
					/>
				}>
				<span className="whitespace-nowrap">
					{tsn('akce.stahnout', {
						count: myFilesSelection.selected.length,
					})}
				</span>
			</Button>
			<GovControlGroup color="error">
				<Button
					aria-label={tsn('akce.smazat')}
					color="error"
					type="outlined"
					size="s"
					isExpandedMobile
					onClick={deleteConfirm.setTrue}
					iconStart={
						<Icon
							type="components"
							name="x-lg"
						/>
					}>
					{tsn('akce.smazat', { count: myFilesSelection.selected.length })}
				</Button>
				<GovDropdown
					position="right"
					color="error"
					type="outlined"
					size="s"
					label={
						<GovIcon
							name="chevron-down"
							type="components"
							slot="icon-start"
						/>
					}>
					<Button
						aria-label={tsn('akce.trvale-odstranit')}
						color="error"
						type="base"
						size="s"
						isExpanded
						onClick={deletePermanentConfirm.setTrue}
						iconStart={
							<Icon
								type="components"
								name="x-lg"
							/>
						}>
						{tsn('akce.trvale-odstranit', {
							count: myFilesSelection.selected.length,
						})}
					</Button>
				</GovDropdown>
			</GovControlGroup>
		</GovFlex>
	);
};

export const ActionsNoFile = () => {
	const { code, deletePermanentConfirm, myFilesSelection } =
		useMojeSouborySeznamContext();
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const tsn = getLocalizeCurried(code);
	return (
		<GovFlex gap="s">
			<Button
				aria-label={tsn('akce.trvale-odstranit')}
				color="error"
				type="outlined"
				size="s"
				isExpandedMobile
				onClick={deletePermanentConfirm.setTrue}
				iconStart={
					<Icon
						type="components"
						name="x-lg"
					/>
				}>
				{tsn('akce.trvale-odstranit', {
					count: myFilesSelection.selected.length,
				})}
			</Button>
		</GovFlex>
	);
};
